import type { MapViewRequestQueries } from "../services/ajax/types";

const updateMapSearchParams = ({ zipcode, distance, sources }: MapViewRequestQueries) => {
  if (!zipcode || !distance || !sources) return;
  const params = new URLSearchParams(window.location.search);
  params.set("zipcode", zipcode);
  params.set("distance", distance);
  params.set("sources", sources);
  window.history.replaceState({}, "", `${window.location.pathname}?${params}`);
};

export default updateMapSearchParams;
